import clientBuilder from "@cornelsen/zoovu-backend-adapter";

/**
 * Zoovu search adapter.
 * Delegates search and suggestion requests to the Zoovu backend via
 * @cornelsen/zoovu-backend-adapter.
 */
export function createZoovuAdapter(backendConfig) {
  const client = buildZoovuClient(backendConfig);

  return {
    fetchResult(searchOptions) {
      return client.fetchResults(searchOptions);
    },

    fetchSuggestions(query, limit) {
      return client
        .fetchSuggestions(query, limit)
        .then((result) =>
          result.suggestions.map((suggestion) => suggestion.term),
        );
    },
  };
}

function buildZoovuClient(conf) {
  if (conf.zoovuProjectId) {
    return clientBuilder({
      projectId: conf.zoovuProjectId,
      timeout: conf.timeout,
    });
  }
  console.error("Missing zoovu project id!");
}
